import APHeading from './APHeading';

export {
  APHeading
};

export default APHeading;
